<template>
  <div id="app">
    <notifications group="appNotif" />
    <router-view name="login" :key="`${$route.fullPath}-login`"></router-view>
    <router-view name="validate" :key="`${$route.fullPath}-validate`"></router-view>
    <router-view name="landing" :key="`${$route.fullPath}-landing`"></router-view>
    <router-view name="policy" :key="`${$route.fullPath}-policy`"></router-view>
    <router-view name="article" :key="`${$route.fullPath}-article`"></router-view>
    <div class="container-fluid">
      <div class="row">
        <router-view name="sidebar" :key="`${$route.fullPath}-sidebar`"></router-view>
        <router-view name="content" :key="`${$route.fullPath}-content`"></router-view>
        <router-view class="col-12" name="report" :key="`${$route.fullPath}-report`"></router-view>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  
}
</script>

<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
